module.exports = __webpack_public_path__ + "media/images/header-shape-1c06358d155af214cea7f5518e8c9039.svg";